import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database'

let config = require('./../../config/config')

let firebaseConfig = {
  apiKey: config.firebase.apiKey,
  authDomain: config.firebase.authDomain,
  projectId: config.firebase.projectId,
  storageBucket: config.firebase.storageBucket,
  messagingSenderId: config.firebase.messagingSenderId,
  appId: config.firebase.appId,
  measurementId: config.firebase.measurementId
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);



const db = firebase.firestore();
const auth=firebase.auth();

const locationCollection = db.collection('locations')


const registeredUsersCollection = db.collection('locations').doc(config.clientName).collection("registeredUsers");
const kioskCollection = db.collection('locations').doc(config.clientName).collection('kiosks');
const dialerCollection = db.collection('locations').doc(config.clientName).collection('dialer');
const callsCollection = db.collection('locations').doc(config.clientName).collection('calls');
const userRolesCollection = db.collection('locations').doc(config.clientName).collection('userRoles');
const userGroupsCollection = db.collection('locations').doc(config.clientName).collection('userGroups');
const appDataCollection = db.collection('locations').doc(config.clientName).collection('appData');
const invitedUsersCollection = db.collection('locations').doc(config.clientName).collection('invitedUsers');
const invitedKiosksCollection = db.collection('locations').doc(config.clientName).collection('invitedKiosks');
const qnaCollection = db.collection('locations').doc(config.clientName).collection('qna');
const userSessionCollection = db.collection('locations').doc(config.clientName).collection('userSession');
const clientConfigCollection = db.collection('locations').doc(config.clientName).collection('clientConfig');
const telepresenceCollection = db.collection('locations').doc(config.clientName).collection('telepresence')
export {
  db,
  auth,
  firebase,
  registeredUsersCollection,
  kioskCollection,
  dialerCollection,
  callsCollection,
  userRolesCollection,
  appDataCollection,
  invitedUsersCollection,
  invitedKiosksCollection,
  qnaCollection,
  userSessionCollection,
  userGroupsCollection,
  clientConfigCollection,
  telepresenceCollection,
  locationCollection
}
